import { IAdvancedFormField } from '~shared/modules/advanced-form/models/advanced-form-fields.model';
import { IAdvancedFormConfig } from '~shared/modules/advanced-form/models/advanced-form.model';
import { FIELD_TYPES } from '~shared/modules/advanced-form/constants/field-types.constant';
import { postalCodeFormValidator } from '~shared/validators/postal-code.validator';

export const BASE_ADDRESS_FIELD_LIST: IAdvancedFormField[] = [
  {
    name: 'firstName',
    label: 'REGULAR.FIELDS.FIRST_NAME.LABEL',
  },
  {
    name: 'lastName',
    label: 'REGULAR.FIELDS.LAST_NAME.LABEL',
  },
  {
    name: 'street',
    label: 'REGULAR.FIELDS.STREET',
  },
  {
    name: 'houseNumber',
    label: 'REGULAR.FIELDS.HOUSE_NUMBER',
  },
  {
    name: 'addressLine2',
    placeholder: 'REGULAR.FIELDS.ADDRESS_ADDITIONAL_INFORMATION.PLACEHOLDER',
    label: 'REGULAR.FIELDS.ADDRESS_ADDITIONAL_INFORMATION.LABEL',
  },
  {
    name: 'country',
    type: FIELD_TYPES.select,
    label: 'REGULAR.FIELDS.COUNTRY.LABEL',
    options: [],
  },
  {
    name: 'postalCode',
    label: 'REGULAR.FIELDS.POSTAL_CODE.LABEL',
  },
  {
    name: 'city',
    label: 'REGULAR.FIELDS.CITY.LABEL',
  },
  {
    name: 'defaultShipping',
    type: FIELD_TYPES.checkbox,
    label: 'REGULAR.FIELDS.SET_AS_DEFAULT_SHIPPING.LABEL',
  },
  {
    name: 'defaultBilling',
    type: FIELD_TYPES.checkbox,
    label: 'REGULAR.FIELDS.SET_AS_DEFAULT_BILLING.LABEL',
  },
];

export const BASE_ADDRESS_ADVANCED_FORM_CONFIG: IAdvancedFormConfig = {
  formValidatorList: [
    postalCodeFormValidator,
  ],
  formSectionList: [
    {
      fieldList: BASE_ADDRESS_FIELD_LIST,
    },
  ],
  actionList: [],
  updateOn: 'blur',
};
